import { ReactElement } from 'react'
import ValidationButton from '../catalog/ValidationButton'
import { SwaapLoader } from '../catalog/SwaapLoader'
import styled from 'styled-components'

interface SwapButtonProps {
  handleOnClick: () => void
  isReadyToSwap: boolean
  message: string | ReactElement
  waiting?: boolean
  icon?: ReactElement
  isSmall?: boolean
  isCompact?: boolean
}
function SwapButton(props: SwapButtonProps) {
  const {
    isReadyToSwap,
    message,
    handleOnClick,
    waiting = false,
    icon,
    isSmall = false,
    isCompact = false,
  } = props
  return (
    <ValidationButton
      isReady={isReadyToSwap}
      onClick={isReadyToSwap ? handleOnClick : () => undefined}
      isSmall={isSmall}
      isCompact={isCompact}
      data-cy={'swap-button'}
      disabled={!isReadyToSwap}
    >
      <div className={'justify-between'}>
        {icon || <Span />}

        <span
          style={{ alignSelf: 'center', width: '100%', alignItems: 'center' }}
        >
          {message}
        </span>

        {waiting ? <SwaapLoader /> : <Span />}
      </div>
    </ValidationButton>
  )
}

export default SwapButton

const Span = styled.div`
  width: 40px;
`
